﻿/*
 * jQuery Validation - Defaults & Extra Methods
 * Based on jQuery Validation - Copyright (c) 2021 Jörn Zaefferer
 * Licensed under the MIT license - http://opensource.org/licenses/MIT
 */
"use strict";

// Default Options
// ------------------------------------------
$.validator.setDefaults({
    focusInvalid: false,
	ignoreTitle: true,
    errorElement: 'span',
    errorClass: 'help-block invalid small',
    highlight: element => {
        $(element).closest('.form-group').addClass('has-error');
    },
    unhighlight: element => {
        $(element).closest('.form-group').removeClass('has-error');
    },
    errorPlacement: (error, element) => {
        if ($(element).closest(".form-group")) {
            $(element).closest(".form-group").append(error);
        } else {
            error.insertAfter(element);
        }
    }
});

// Additional Methods
// ------------------------------------------

// Select2-Required
// Sets whether or not to trigger "required" for Select2 dropdowns.
// Takes the default "-1" value into account.
$.validator.addMethod("select2Required",value => { 
	return value.toString() !== "-1"; 
}, "This field is required.");

// Integer
// Requires a valid integer for the input.
$.validator.addMethod("integer", function( value, element ) {
	return this.optional( element ) || /^-?\d+$/.test( value );
}, "A positive or negative non-decimal number please" );